import script from "./TableTd.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableTd.vue?vue&type=script&setup=true&lang=ts"

import "./TableTd.vue?vue&type=style&index=0&id=cc2d6cd2&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc2d6cd2"]])

export default __exports__